import { render, staticRenderFns } from "./contactDataLabels.vue?vue&type=template&id=128196a9&"
import script from "./contactDataLabels.vue?vue&type=script&lang=ts&"
export * from "./contactDataLabels.vue?vue&type=script&lang=ts&"
import style0 from "./contactDataLabels.vue?vue&type=style&index=0&id=128196a9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports